@use "@fukuri-admins/ui/layout" as *;

.Root {
  &__Toolbar {
    margin-bottom: spacing("16");
  }

  &__SearchInput {
    width: 270px;
  }

  &__SearchIcon {
    color: inherit;
  }

  &__Stats {
    margin-bottom: spacing("16");
    font-size: 13px;
    color: $TextLabel;

    &__Count {
      font-weight: bold;
      color: $Text;
    }
  }

  .tableWrapper {
    margin-bottom: spacing("16");
    overflow-x: auto;
  }
}
